/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { IAai20Visitor } from '../visitors/IAai20Visitor';
import { Node } from '../../../core/models/Node';
import { PasswordOAuthFlow } from '../../../core/models/common/PasswordOAuthFlow';
import { IVisitor } from '../../../core/visitors/IVisitor';
import { Document } from '../../../core/models/Document';

/**
 * Constructor.
 * @param {Node} parent
 * @class
 * @extends PasswordOAuthFlow
 * @author Jakub Senko<jsenko@redhat.com>
 */
export class Aai20PasswordOAuthFlow extends PasswordOAuthFlow {
    public constructor(parent? : any) {
        if(((parent != null && parent instanceof <any>Node) || parent === null)) {
            let __args = arguments;
            super();
            (() => {
                /* requireNonNull */if(parent==null){throw new Error('cannot be null')};
                this._parent = parent;
                this._ownerDocument = parent.ownerDocument();
            })();
        } else if(parent === undefined) {
            let __args = arguments;
            super();
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let v : IAai20Visitor = <IAai20Visitor><any>visitor;
        v.visitPasswordOAuthFlow(this);
    }
}
Aai20PasswordOAuthFlow["__class"] = "io.apicurio.datamodels.asyncapi.v2.models.Aai20PasswordOAuthFlow";
Aai20PasswordOAuthFlow["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




